'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Logo = _interopRequireDefault(require("Pure/Logo"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const app = window.app;
class PasswordRecoveryPage extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      status_messages: {}
    });
    (0, _defineProperty2.default)(this, "handleChange", _ref => {
      let {
        e,
        value,
        name
      } = _ref;
      const component = this,
        props = this.props,
        state = this.state;
      let status_messages = state.status_messages;
      delete status_messages[name];
      component.setState({
        [name]: value,
        error: undefined,
        status_messages: status_messages
      });
    });
    (0, _defineProperty2.default)(this, "requestPassword", e => {
      const component = this,
        props = this.props,
        state = this.state;
      qwest.post('/user/recover-password', {
        login: state.login
      }).then(function (xhr, response) {
        component.setState({
          info: 'Un e-mail comportant un lien pour créer votre ' + 'nouveau mot de passe vous a été envoyé par e-mail.'
        });
      }).catch(function (error, xhr, response) {
        console.error((response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.raw) || error);
        component.setState(_objectSpread({}, (0, _getErrorsFromResponse.default)({
          response: response
        })));
      });
    });
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const message = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let submit;
    if (!state.info) {
      submit = /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: component.requestPassword
      }, "Valider", loader));
    }
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, props, /*#__PURE__*/_react.default.createElement("div", {
      className: "simple-page"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content",
      style: {
        width: '450px',
        maxWidth: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-text-center u-margin-bottom-30"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "auth-logo-link",
      href: (0, _Routing.URL)('Login')
    }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
      style: {
        width: '240px',
        maxWidth: '100%',
        margin: 'auto'
      }
    }))), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['login'],
      name: "login",
      label: "E-mail de connexion",
      status: state.status_messages
    }), message, submit)));
    return output;
  }
}
exports.default = PasswordRecoveryPage;
